/**
 * Checks if a redirect path is safe to use for internal navigation.
 * A path is considered safe if it starts with a single '/' and not with '//',
 * which prevents "Open Redirect" vulnerabilities by ensuring the redirect
 * stays within the current domain.
 * @param path - The redirect path to validate.
 * @returns True if the path is safe for internal redirection, false otherwise.
 */
export const isSafeRedirect = (path: string) => {
  return path.startsWith('/') && !path.startsWith('//');
};
